import * as React from "react";
export class LiveIndicator extends React.Component {
    render() {
        let clsMdf = this.props.modifier ? ` rj-superbaner__icon-live--${this.props.modifier}` : "";
        let dataUat = this.props.modifier ? `superbaner-icon-live-${this.props.modifier}` : "superbaner-icon-live";
        return (React.createElement("span", { className: `rj-superbaner__icon-live${clsMdf}`, "data-uat": dataUat }, this.props.liveText));
    }
}
//# sourceMappingURL=LiveIndicator.js.map